/* global $ */
/* global URLS */
/* global gettext */

(function (scope) {
  "use strict";

  /**
   * @constructor
   */
  var PrintQuantityDecorator = (scope.PrintQuantityDecorator = function () {
    this.currentQuantity = 1;
    this.delayQuantityClick = 500;
    this.timerQuantity = null;
    this.designUpdated = null;
    this.$quantity = null;

    this.$el.on("change", ".2Dquantity", this.quantityUpdated.bind(this));
    this.$el.on("click", ".minus", this.quantityDecreased.bind(this));
    this.$el.on("click", ".plus", this.quantityIncreased.bind(this));
  });

  /**
   * Updated quantity callback
   * @private
   */
  PrintQuantityDecorator.prototype.quantityUpdated = function (event) {
    this.designUpdated = $(event.currentTarget)
      .parents("[data-uuid]")
      .data("uuid");
    var val = $(event.currentTarget).val();
    var min = parseInt($(event.currentTarget).attr("min"), 10);
    var max = parseInt($(event.currentTarget).attr("max"), 10);

    if (val < min) {
      val = min;
      $(event.currentTarget).val(val);
      this.controller.notify(
        "warn",
        gettext("Quantity cannot be under XXXX").replace("XXXX", min),
        true,
        this.designUpdated
      );
    }
    if (val > max) {
      val = max;
      $(event.currentTarget).val(val);
      this.controller.notify(
        "warn",
        gettext("Quantity cannot be more than XXXX").replace("XXXX", max),
        true,
        this.designUpdated
      );
    }

    this.currentQuantity = val;
    this.notifyController();
  };

  /**
   * Updated quantity via minus button callback
   * @private
   */
  PrintQuantityDecorator.prototype.quantityDecreased = function (event) {
    event.preventDefault();

    this.designUpdated = $(event.currentTarget)
      .parents("[data-uuid]")
      .data("uuid");
    this.$quantity = $(event.currentTarget).parent().find("input[type=number]");

    var quantity = parseInt(this.$quantity.val()) - 1;

    if (quantity >= parseInt(this.$quantity.attr("min"), 10)) {
      this.$quantity.val(quantity);
      this.currentQuantity = quantity;
      if (this.timerQuantity) {
        clearTimeout(this.timerQuantity);
        this.timerQuantity = null;
      }

      this.timerQuantity = window.setTimeout(
        this.notifyController.bind(this),
        this.delayQuantityClick
      );
    }
  };

  /**
   * Updated quantity via plus button callback
   * @private
   */
  PrintQuantityDecorator.prototype.quantityIncreased = function (event) {
    event.preventDefault();

    this.designUpdated = $(event.currentTarget)
      .parents("[data-uuid]")
      .data("uuid");
    this.$quantity = $(event.currentTarget).parent().find("input[type=number]");

    var quantity = parseInt(this.$quantity.val()) + 1;

    if (quantity <= parseInt(this.$quantity.attr("max"), 10)) {
      this.$quantity.val(quantity);

      this.currentQuantity = quantity;
      if (this.timerQuantity) {
        clearTimeout(this.timerQuantity);
        this.timerQuantity = null;
      }

      this.timerQuantity = window.setTimeout(
        this.notifyController.bind(this),
        this.delayQuantityClick
      );
    }
  };

  PrintQuantityDecorator.prototype.notifyController = function () {
    var design = this.designUpdated || this.design.model_uuid;
    this.controller.updateQuantity(this.currentQuantity, design);
  };
})((window.sculpteo = window.sculpteo || {}));
